
const NewCarDetails =[

    { 
         name : "Honda Civic",
         description :"Honda`s best selling sedan only for Rs 40Lacs",
        pic:require("./images/civic.jpg"),
        },
    
    {
         name : "Suzuki Cultus",
         description :"Suzuki`s best selling Hatchback only for Rs 20Lacs",
        pic:require("./images/cultus.jpg")
    },

    {
         name : "Toyota Revo",
         description :"Toyota best selling truck only for Rs 93Lacs",
        pic:require("./images/Hilux.jpg")
    },
 
    
    {
         name : "Honda BRV",
         description :"Honda`s best selling mini jeep only for Rs 40 Lacs",
        pic:require("./images/hondabrv.jpg")
    },

    
    {
        name : "Suzuki Swift",
        description :"Suzuki luxurious hatchback for only for Rs 25 Lacs",
       pic:require("./images/swift.jpg")
   },

   
   {
    name : "Changan Alsvin",
    description :"Changan sedan the best low price sedan available for only Rs 45 Lac",
   pic:require("./images/alsvin.jpg")
},


{
    name : "Hondai Sonata",
    description :"Hondai Sonata is the most luxouris car in whole Pakistan with Rs 80 Lacs",
   pic:require("./images/sonata.jpg")
},


{
    name : "Toyota Land Crusier",
    description :"Toyota Land Crusier is the best roading 4x4 pajero available only for Rs 3 crore",
   pic:require("./images/crusier.jpg")
},
    ]
    
    export function getNewCarDetails(){return NewCarDetails;}
    
    
    